import TebraPayBanner from 'shared-assets/components/PaymentSolutions/PaymentSettings/TebraPayBanner';

angular
  .module(
    'kareo.ui.shared.directives.tebra-pay-banner',
    ['react'],
  )
  .directive('tebraPayBanner', dcTebraPayBanner);

dcTebraPayBanner.$inject = ['reactDirective'];

function dcTebraPayBanner(reactDirective) {
  return reactDirective(TebraPayBanner);
}
